export const priorityTypes = {
  allClientCameras: 1,
  allTariffCameras: 2,
  allServerCameras: 3,
  cameraByNimbleId: 4,
  billing: 5,
}

export const priorityTypesText = {
  [priorityTypes.allClientCameras]: "Все камеры клиента",
  [priorityTypes.allTariffCameras]: "Все камеры тарифа",
  [priorityTypes.allServerCameras]: "Все камеры сервера",
  [priorityTypes.cameraByNimbleId]: "Камера по nimble_id",
  [priorityTypes.billing]: "Биллинг",
}
